<template>
  <div class="analytics alert-analytics mb-3">
    <data-warning
      :disabled="isDisabled"
      :type="analyticsType"
      :published-recently="sentAtPast2hours"
      :incomplete-time-message="'All data will become available 2 hours after sending.'"
    />

    <stats
      :data="basicMetrics"
      :props="basicMetricsShow"
      :min-width="minWidth"
      :disabled="isDisabled"
    />
  </div>
</template>

<script>
import moment from 'moment'

import AnalyticsMixin from '@/analytics/mixins/AnalyticsMixin'
import DataWarning from '@/components/DataWarning'
import Stats from '@/components/Stats'

export default {
  components: {
    DataWarning,
    Stats,
  },
  mixins: [AnalyticsMixin],
  data () {
    return {
      analyticsType: 'alert',
      basicMetricsShow: ['sendgridProcessedUnique', 'sendgridDeliveredUnique', 'sendgridOpenRate', 'sendgridClickedUnique'],
      basicMetricProps: ['sendgridProcessedUnique', 'sendgridDeliveredUnique', 'sendgridOpenRate', 'sendgridClickedUnique'],
      timeframe: 'this_5_years',
      enableWarning: true,
    }
  },
  computed: {
    sources () {
      return {sendgrid: ['email_processed', 'email_delivered', 'email_open', 'email_click']}
    },
    sentAtPast2hours () {
      if (this.data.sent_at !== null && this.data.sent_at !== undefined) {
        const before = moment().subtract(2, 'hour')
        const curr = moment(this.data.sent_at)
        return before < curr
      }

      return null
    },
  },
  watch: {
    keenAnalyses: function (newData, oldData) {
      if (newData !== null) {
        this.constructBasicMetrics(this.analyticsType)
      }
    },
  },
}
</script>
